import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Notice } from '../models/notice.model';
import { ARGCSDownloadInformation } from '../models/agrorendement-common.model';

@Injectable({ providedIn: 'root' })
export class NoticeService {
  private noticeUrl = '/notice';

  private notices: Notice[];
  toolUrl = '/notice';

  constructor(private http: HttpClient) {
    const obs = this.getNotices();
  }

  getNotices(): Observable<Notice[]> {
    if (this.notices) {
      return of(this.notices);
    }

    return this.http.get<any>(this.noticeUrl).pipe(
      map((response) => {
        const notices: Notice[] = response.data;
        this.notices = notices;
        return notices;
      }),
      catchError(this.handleError),
    );
  }

  public downloadResult(result: string): Observable<ARGCSDownloadInformation> {
    const url = `${this.toolUrl}/${result}/download`;
    return <Observable<ARGCSDownloadInformation>>this.http.get<any>(url).pipe(
      map((res) => res.data),
      catchError(this.handleError),
    );
  }

  private handleError(error: any) {
    // FIXME
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }
}
